import { ref } from 'vue'

const isLoading = ref(false)
const isAutoLoadingDisabled = ref(false)
const loadingMessage = ref('Aguarde')
let requestCount = 0

export function useLoading() {

    function show(message = 'Aguarde') {
        if (isAutoLoadingDisabled.value) return
        requestCount++
        loadingMessage.value = message
        isLoading.value = true
    }

    function hide() {
        if (isAutoLoadingDisabled.value) return
        requestCount = Math.max(0, requestCount - 1)
        if (requestCount === 0) {
            isLoading.value = false
            loadingMessage.value = 'Aguarde'
        }
    }

    function disableAutoLoading() {
        isAutoLoadingDisabled.value = true
    }

    function enableAutoLoading() {
        isAutoLoadingDisabled.value = false
        requestCount = 0
        isLoading.value = false
        loadingMessage.value = 'Aguarde'
    }

    function updateMessage(message) {
        loadingMessage.value = message
    }

    async function withLoading(fn) {
        try {
            show()
            return await fn()
        } finally {
            hide()
        }
    }

    return {
        isLoading,
        loadingMessage,
        isAutoLoadingDisabled,
        show,
        hide,
        withLoading,
        disableAutoLoading,
        enableAutoLoading,
        updateMessage
    }
}